export enum ApiStatusMessage {
  SUCCESS = 'Success',
  ERROR = 'Error',
  NOT_FOUND = 'NotFound',
}
